module.exports = __webpack_public_path__ + "images/circle-1.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/circle-1.png
// module id = 840
// module chunks = 125